module.exports = __webpack_public_path__ + "img/1.02d6daed.png";